<template lang="pug">
  .module__main
    .module-content__container
      .filters__container
        .dates__container
          .date__container
            el-date-picker(
              v-model="date"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        .search__container
          .search__block.mr5(v-if="isNeedToChooseProject")
            el-select(v-model="searchProject" @change="updateDefaultSearchProject()" placeholder="Проект")
              el-option(label="Все проекты" value="")
              el-option(v-for="project in availableProjects" :key="`search-project-${project}`" :label="project" :value="project")
          .search__block.mr5
            el-select(v-model="searchStatus" @change="updateDefaultSearchStatus()" placeholder="Статус")
              el-option(label="Все статусы" value="")
              el-option(v-for="(label, status) in statuses" :key="`search-status-${status}`" :label="label" :value="status")
          .search__block.mr5
            el-select(v-model="searchBlockchain" @change="updateDefaultSearchBlockchain()" placeholder="Криптовалюта")
              el-option(label="Все криптовалюты" value="")
              el-option(v-for="blockchain in blockchains" :key="`search-blockchain-${blockchain}`" :label="blockchain" :value="blockchain")
              el-select(v-if="searchBlockchain === 'BTC'" v-slot="suffix" v-model="searchIsClean" @change="updateDefaultSearchIsClean" placeholder="Чистота")
                el-option(label="Все" value="")
                el-option(label="Чистый" value="true")
                el-option(label="Грязный" value="false")
        .search__container.search-right
          .search__block
            el-select(v-model="searchMode" @change="updateDefaultSearchMode()")
              el-option(v-for="(mode, key) in searchModes" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
            el-input(v-model="searchValue" :placeholder="searchModes[searchMode].title")
              i.el-input__icon.el-icon-search(slot="suffix" @click="searchOrder()")
            i.el-icon-close.search-reset__btn(v-if="searchLoaded" @click="resetSearch()")
      .control-buttons__container
        .new-wallet__container
          el-button(size="mini" @click="enableOrderAdding") Добавить новую
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedOrders"
            :row-class-name="tableRowClassName"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(label="Пользователь" width="150")
              template(v-slot:default="scope")
                div {{ scope.row.user }}
            el-table-column(prop="id" label="ID" width="220")
              template(v-slot:default="scope")
                div {{ scope.row.id }}
                div(v-if="scope.row.customId") ({{ scope.row.customId }})
                div(v-if="scope.row.project") ({{ scope.row.project  }})
            el-table-column(label="Адрес вывода" width="200")
              template(v-slot:default="scope")
                .address__container(
                  @click="copyTextToClipboard(scope.row.address)"
                  :class="scope.row.showClean ? ['clean'] : ''"
                  )
                  img.address-blockchain-icon(v-if="scope.row.blockchain === 'BTC'" src="@/assets/btc-logo.svg" alt="BTC")
                  img.address-blockchain-icon(v-else-if="scope.row.blockchain === 'ETH'" src="@/assets/eth-logo.svg" alt="ETH")
                  img.address-blockchain-icon(v-else-if="scope.row.blockchain === 'TRX'" src="@/assets/trx-logo.svg" alt="TRX")
                  span.ml5 {{ scope.row.address }}
                  .clean-note(v-if="scope.row.showClean") Чистый
            el-table-column(label="Количество" width="160")
              template(v-slot:default="scope")
                div Заявка: {{ scope.row.amount }} {{ scope.row.cryptoType }}
                div Комиссия: {{ scope.row.fee }} {{ scope.row.cryptoType }}
            el-table-column(prop="status" label="Статус" width="180")
              template(v-slot:default="scope")
                div
                  span {{ scope.row.status }}
                  span(v-if="scope.row.status === 'Ошибка' && scope.row.error") {{ ` (${scope.row.error})` }}
                .action-buttons__container
                  el-button.action-button(v-if="scope.row.canConfirm" type="success" size="mini" @click="orderAction(scope.row.id, 'confirm')") Подтвердить
                  el-button.action-button(v-if="scope.row.canCancel" type="danger" size="mini" @click="orderAction(scope.row.id, 'cancel')") Отменить
                  el-button.action-button(v-if="scope.row.canRestart" type="warning" size="mini" @click="orderAction(scope.row.id, 'restart')") Перезапросить
            el-table-column(prop="date" label="Дата" width="150")
            el-table-column(prop="txId" label="ID транзакции" width="250")
              template(v-slot:default="scope" )
                a(v-if="scope.row.txLink" :href="scope.row.txLink" target="_blank") {{ scope.row.txId }}
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='orders.pagination.total',
            :page-size="per_page",
            :current-page='orders.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadOrders',
          )
    el-dialog(:visible.sync="isOrderAdding" :before-close="resetOrderAdding" title="Добавление вывода" width="30%")
      .dialog__container
        .dialog-input__block(v-if="isNeedToChooseProject")
          .dialog-input__title
            span Проект
            span.dialog-input__required
          el-select(v-model="addingOrder.project" placeholder="Проект")
            el-option(v-for="project in availableProjects" :label="project" :value="project" :key="`new-order-project-${project}`")
        .dialog-input__block
          .dialog-input__title
            span Криптовалюта
            span.dialog-input__required
          el-select(v-model="addingOrder.cryptoType" placeholder="Криптовалюта" @change="updateAddingOrderBlockchainOnCryptoTypeChange")
            el-option(v-for="cryptoType in cryptoTypes" :label="cryptoType" :value="cryptoType" :key="`new-order-cryptoType-${cryptoType}`")
        .dialog-input__block(v-if="isNeedToChooseBlockchain")
          .dialog-input__title
            span Блокчейн
            span.dialog-input__required
          el-select(v-model="addingOrder.blockchain" placeholder="Блокчейн")
            el-option(v-for="blockchain in blockchainOptions" :label="blockchain" :value="blockchain" :key="`new-order-blockchain-${blockchain}`")
        .dialog-input__block(v-if="isNeedToChooseCleanType")
          .dialog-input__title
            span Чистота монеты
            span.dialog-input__required
          el-select(v-model="addingOrder.cleanType" placeholder="Выберите тип монеты")
            el-option(label="Грязный" value="dirty")
            el-option(label="Чистый" value="clean")
        .dialog-input__block
          .dialog-input__title
            span Адрес вывода
            span.dialog-input__required
          el-input(v-model="addingOrder.address" :placeholder="`Адрес в сети ${addingOrder.blockchain}`")
        .dialog-input__block
          .dialog-input__title
            span Сумма вывода
            span.dialog-input__required
          el-input(type="number" v-model="addingOrder.amount" placeholder="Сумма")
            .amount-commission-note(v-if="addingOrderFee" slot="append")
              .color-danger Комиссия: {{ addingOrderFee }}
              .color-primary.cursor-pointer(v-if="addingOrderAvailableBalance" @click="setMaxAvailableBalanceToAddingOrderAmount") Максимальный вывод: {{ addingOrderAvailableBalance }}
        .dialog-input__block
          .dialog-input__title Дополнительный ID (ID клиента)
          el-input(v-model="addingOrder.customId" placeholder="ID")
        .dialog__buttons
          el-button(type="success" :disabled="!!newOrderDataError" @click="requestOrder") Запросить
          el-button(type="danger" @click="resetOrderAdding()") Отменить
          .error-text.color-danger.ml5.mt5(v-if="!!newOrderDataError")
            i.el-icon-warning
            span.ml5 {{ newOrderDataError }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  ADD_ORDER,
  BUMP_ORDER,
  CANCEL_ORDER,
  CONFIRM_ORDER,
  LOAD_ORDERS_LIST,
  RESTART_ORDER,
} from '@/store/const/orders';
import instruments from '@/mixins/instruments';

export default {
  name: 'Orders',
  mixins: [instruments],
  data() {
    return {
      page: 1,
      per_page: 50,
      searchValue: '',
      searchLoaded: false,
      searchMode: localStorage.getItem('orders_searchMode') || 'id',
      searchProject: localStorage.getItem('orders_searchProject') || '',
      searchStatus: localStorage.getItem('orders_searchStatus') || '',
      searchBlockchain: localStorage.getItem('orders_searchBlockchain') || '',
      searchIsClean: localStorage.getItem('orders_searchIsClean') || '',
      intervalHandle: null,
      isFirstLoading: true,
      date: '',
      dateOptions: {
        shortcuts: [
          {
            text: 'Сегодня',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Сутки',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Вчера',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0, 0);
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Неделя',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Месяц',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '3 месяца',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      isOrderAdding: false,
      addingOrder: {
        amount: 0,
        cryptoType: '',
        blockchain: '',
        address: '',
        customId: '',
        project: undefined,
        cleanType: '',
      },
    };
  },
  watch: {
    availableProjects(updatedProjects) {
      if (!this.isNeedToChooseProject || (this.searchProject && !updatedProjects.includes(this.searchProject))) {
        this.searchProject = '';
        this.updateDefaultSearchProject();
      }
    },
  },
  async mounted() {
    await this.loadOrders();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters(['loading', 'error']),
    ...mapGetters('orders', ['orders', 'statuses']),
    ...mapGetters('settings', ['timeZoneOptions', 'blockchains', 'cryptoTypes']),
    ...mapGetters('user', [
      'isAdmin',
      'isSuperadmin',
      'isSupport',
      'isClient',
      'username',
      'availableProjects',
      'fee',
      'feeClean',
      'feeUsdt',
      'feeCleanUsdt',
      'balanceAvailable',
      'balanceAvailableUsdt',
    ]),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_ORDERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_ORDERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_ORDERS_LIST);
    },
    hasPagination() {
      return this.orders.pagination.total > this.per_page;
    },
    searchModes() {
      const modes = {
        id: { locale: 'По ID заявки', title: 'ID заявки' },
        customId: { locale: 'По ID клиента', title: 'ID клиента' },
        address: { locale: 'По кошельку', title: 'Адрес кошелька' },
        txid: { locale: 'По транзакции', title: 'ID транзакции' },
      };
      if (this.isAdmin || this.isSupport) {
        modes.user = { locale: 'По клиенту', title: 'Имя пользователя' };
      }
      return modes;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() - 180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        };
      } else {
        return null;
      }
    },
    formattedOrders() {
      return this.orders.list.map((order) => {
        const date = new Date(order.createdAt);
        let txLink;
        if (order.txId) {
          if (order.blockchain === 'BTC') {
            txLink = 'https://live.blockcypher.com/btc/tx/' + order.txId;
          } else if (order.blockchain === 'ETH') {
            txLink = 'https://etherscan.io/tx/' + order.txId;
          } else if (order.blockchain === 'TRX') {
            txLink = 'https://tronscan.org/#/transaction/' + order.txId;
          }
        }
        return {
          ...order,
          status: order.confirmed ? 'Подтвержден ✔' : this.statuses[order.status] || order.status,
          date: date.toLocaleString('ru-RU', this.timeZoneOptions),
          txLink,
          canConfirm: (this.isAdmin || this.isSupport) && order.status === 'checking',
          canCancel: (this.isAdmin || this.isClient) && order.status === 'wait_send',
          canRestart: false && (this.isAdmin || this.isSupport) && order.status === 'error', // TODO: пофиксить, когда нужно будет добавить функционал
          showClean: order.cryptoType === 'BTC' && order.isClean,
        };
      });
    },
    blockchainOptions() {
      if (this.addingOrder.cryptoType) {
        return this.addingOrder.cryptoType === 'BTC' ? ['BTC'] : ['TRX', 'ETH'];
      }
      return null;
    },
    newOrderDataError() {
      if (this.isNeedToSpecifyProject && !this.addingOrder.project) {
        return 'Не выбран проект';
      }
      if (!this.addingOrder.cryptoType) {
        return 'Не указана криптовалюта';
      }
      if (this.isNeedToChooseCleanType && !this.addingOrder.cleanType) {
        return 'Не выбрана чистота криптовалюты';
      }
      if (!this.addingOrder.address) {
        return 'Не указан адрес вывода';
      }
      if (this.addingOrder.blockchain === 'ETH' && !this.isValidEthAddress(this.addingOrder.address)) {
        return 'Адрес вывода не валиден в сети ETH';
      }
      if (this.addingOrder.blockchain === 'TRX' && !this.isValidTrxAddress(this.addingOrder.address)) {
        return 'Адрес вывода не валиден в сети TRX';
      }
      if (this.addingOrder.blockchain === 'BTC' && !this.isValidBtcAddress(this.addingOrder.address)) {
        return 'Адрес вывода не валиден в сети BTC';
      }
      if (!this.addingOrder.amount) {
        return 'Не указана сумма вывода';
      }
      return '';
    },
    isNeedToSpecifyProject() {
      return this.availableProjects.length > 0;
    },
    isNeedToChooseProject() {
      return this.availableProjects.length > 1;
    },
    isNeedToChooseBlockchain() {
      return this.blockchainOptions?.length > 1;
    },
    isNeedToChooseCleanType() {
      return this.addingOrder.blockchain === 'BTC';
    },
    addingOrderFee() {
      if (this.addingOrder.cryptoType === 'BTC' && this.addingOrder.cleanType) {
        return this.addingOrder.cleanType === 'clean' ? this.feeClean : this.fee;
      } else if (this.addingOrder.cryptoType === 'USDT' && this.addingOrder.cleanType) {
        return this.addingOrder.cleanType === 'clean' ? this.feeCleanUsdt : this.feeUsdt;
      }

      return 0;
    },
    addingOrderAvailableBalance() {
      if (this.addingOrderFee) {
        if (this.addingOrder.cryptoType === 'BTC') {
          return this.floatPlus(this.balanceAvailable, -this.addingOrderFee);
        } else if (this.addingOrder.cryptoType === 'USDT') {
          return this.floatPlus(this.balanceAvailableUsdt, -this.addingOrderFee);
        }
      }

      return 0;
    }
  },
  methods: {
    ...mapActions('orders', {
      loadOrdersList: LOAD_ORDERS_LIST,
      addOrder: ADD_ORDER,
      confirmOrder: CONFIRM_ORDER,
      restartOrder: RESTART_ORDER,
      bumpOrder: BUMP_ORDER,
      cancelOrder: CANCEL_ORDER,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadOrders(this.page), 10000);
    },
    tableRowClassName({ row }) {
      if (row.blockchain === 'BTC') {
        return 'btc-row';
      } else if (row.blockchain === 'ETH') {
        return 'eth-row';
      } else if (row.blockchain === 'TRX') {
        return 'trx-row';
      }
      return '';
    },
    async loadOrders(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
      };
      if (this.searchValue) {
        params[this.searchMode] = this.searchValue;
      }
      if (this.date) {
        params.from = this.dates.from;
        params.to = this.dates.to;
      }
      if (this.searchProject) {
        params.project = this.searchProject;
      }
      if (this.searchStatus) {
        params.status = this.searchStatus;
      }
      if (this.searchBlockchain) {
        params.blockchain = this.searchBlockchain;
      }
      if (this.searchIsClean) {
        params.isClean = this.searchIsClean;
      }
      await this.loadOrdersList({ params });
      this.page = page;
      this.searchLoaded = !!this.searchValue;
    },
    async searchOrder() {
      clearInterval(this.intervalHandle);
      this.searchValue = this.searchValue.trim();
      await this.loadOrders(1);
    },
    resetSearch() {
      this.searchLoaded = false;
      this.searchValue = '';
      this.loadOrders();
      this.startInterval();
    },
    updateDefaultSearchMode() {
      localStorage.setItem('orders_searchMode', this.searchMode);
    },
    updateDefaultSearchProject() {
      localStorage.setItem('orders_searchProject', this.searchProject);
    },
    updateDefaultSearchStatus() {
      localStorage.setItem('orders_searchStatus', this.searchStatus);
    },
    updateDefaultSearchBlockchain() {
      localStorage.setItem('orders_searchBlockchain', this.searchBlockchain);
    },
    updateDefaultSearchIsClean() {
      localStorage.setItem('orders_searchIsClean', this.searchIsClean);
    },
    enableOrderAdding() {
      if (this.availableProjects.length === 1) {
        this.addingOrder.project = this.availableProjects[0];
      }
      this.isOrderAdding = true;
    },
    updateAddingOrderBlockchainOnCryptoTypeChange() {
      if (this.addingOrder.cryptoType === 'BTC') {
        this.addingOrder.blockchain = 'BTC';
        this.addingOrder.cleanType = '';
      } else if (this.addingOrder.cryptoType === 'USDT') {
        this.addingOrder.blockchain = 'TRX';
      }
    },
    resetOrderAdding() {
      this.isOrderAdding = false;
      this.addingOrder.amount = 0;
      this.addingOrder.cryptoType = '';
      this.addingOrder.blockchain = '';
      this.addingOrder.customId = '';
      this.addingOrder.address = '';
      this.addingOrder.cleanType = '';
      this.addingOrder.project = undefined;
    },
    async resetOrderAddingAndLoadOrders() {
      this.resetOrderAdding();
      await this.loadOrders(this.page);
    },
    async requestOrder() {
      if (!this.addingOrder.address || !this.addingOrder.amount) {
        return this.$message.warning('Не указан адрес или сумма вывода');
      }
      this.addingOrder.amount = parseFloat(this.addingOrder.amount);
      const request = await this.addOrder({
        amount: parseFloat(this.addingOrder.amount),
        cryptoType: this.addingOrder.cryptoType,
        blockchain: this.addingOrder.blockchain,
        address: this.addingOrder.address,
        customId: this.addingOrder.customId,
        project: this.addingOrder.project,
        isClean: this.addingOrder.cleanType === 'clean',
      },);
      await this.notifyRequestResult({
        request,
        successMessage: 'Вывод успешно добавлен',
        methodOnSuccess: this.resetOrderAddingAndLoadOrders,
      });
    },
    async orderAction(id, type, params) {
      const allowedActionTypes = ['confirm', 'restart', 'cancel'];
      if (!allowedActionTypes.includes(type)) {
        return this.$message.warning(`Неизвестный тип действия для вывода: ${type}`);
      }
      let typeLocale = '';
      let action;
      switch (type) {
        case 'confirm':
          typeLocale = 'подтвердить';
          action = this.confirmOrder;
          break;
        case 'restart':
          typeLocale = 'перезапустить';
          action = this.restartOrder;
          break;
        case 'bump':
          typeLocale = 'ускорить';
          action = this.bumpOrder;
          break;
        case 'cancel':
          typeLocale = 'отменить';
          action = this.cancelOrder;
          break;
      }

      this.$confirm(`Вы уверены, что хотите ${typeLocale} вывод ${id}?`, 'Подтверждение')
        .then(async () => {
          const request = await action({ id, params });
          await this.notifyRequestResult({
            request,
            successMessage: 'Вывод успешно изменен',
          });
        })
        .catch(() => {
          this.$message.info('Изменение отменено');
        });
    },
    setMaxAvailableBalanceToAddingOrderAmount() {
      this.addingOrder.amount = this.addingOrderAvailableBalance;
    }
  },
};
</script>
<style scoped>
.filters__container {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border: 1px solid #c9c9c9;
}

.search__container {
  display: flex;
  justify-content: center;
}

.search-right {
  align-items: flex-end;
}

.search__block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-reset__btn {
  padding: 11px;
  background-color: #e95050;
  cursor: pointer;
}

.search-reset__btn:hover {
  padding: 10px;
  background-color: #dd3636;
  border: 1px solid #850202;
}

.search__container .el-select {
  width: 250px;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.control-buttons__container {
  margin-bottom: 5px;
}

.action-buttons__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.action-button {
  width: 100%;
  margin: 2px auto !important;
}

.address__container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.address__container.clean {
  color: #59ad30;
  border: 1px solid #67c23a;
  padding: 2px;
  position: relative;
}

.address__container span {
  font-size: 10px;
}

.address-blockchain-icon {
  height: 18px;
  width: 25px;
}

.error-text {
  font-size: 12px;
}

.amount-commission-note {
  padding: 2px;
  font-size: 10px;
}
</style>
<style>
.el-table__row.btc-row {
  background: #fdf0df;
}

.el-table__row.trx-row {
  background: #fde1e1;
}

.el-table__row.eth-row {
  background: #e2fff7;
}

td .address__container .clean-note {
  position: absolute;
  color: white;
  border: 1px solid #224710;
  background-color: #438324;
  bottom: -1px;
  right: -10px;
  padding: 0 2px;
  border-radius: 4px;
  font-size: 10px;
}
</style>
